/*
包含一些常量值的模块
//  */

export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN // api base url 
export const ADMIN_DOMAIN = process.env.REACT_APP_ADMIN_DOMAIN // api base url (超管 -- 用于事件埋点)
export const API_OSS = process.env.REACT_APP_API_OSS // api 阿里oss

//page speed
export const PAGE_DOMAIN = process.env.REACT_APP_PAGE_DOMAIN // api base url

//gmail账户所有者：魏浩
// export const REDIRECT_URI = 'https://app.seoant.com.com/auth/googleSearchConsoleAuth'//老版本url
// export const REDIRECT_URI = 'https://test-seomaster.giraffly.com/searchAppearance/GoogleSearchConsoleV2'
export const REDIRECT_URI = 'https://app.seoant.com/searchAppearance/GoogleSearchConsoleV2'
export const CLLIENT_ID   = '175486626803-21stcuu686e6amc6mfue1rcssjnlir0d.apps.googleusercontent.com'
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET
export const GOOGLLE_SEARCH_CONSOLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/auth?redirect_uri='+REDIRECT_URI+'&response_type=code&client_id='+CLLIENT_ID+'&scope=https://www.googleapis.com/auth/webmasters+https://www.googleapis.com/auth/webmasters.readonly+https://www.googleapis.com/auth/userinfo.email&approval_prompt=force&access_type=offline'; // google Search Console 授权请求地址    

// export const MIDDLE_INTEGRATION_API = "https://ztapi.trackingmore.com"; //测试
export const MIDDLE_INTEGRATION_API = "https://mpapi.channelwill.com";

export const CRISP_TOKEN = process.env.REACT_APP_CRISP_TOKEN

export const VITE_SHOPIFY_APP_KEY = process.env.REACT_APP_VITE_SHOPIFY_APP_KEY 